import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.33484 9.17636C1.88839 9.63191 1.88839 10.3717 2.33484 10.8273L8.04944 16.6583C8.4959 17.1139 9.22094 17.1139 9.66739 16.6583C10.1138 16.2028 10.1138 15.463 9.66739 15.0074L5.89932 11.1662H16.8571C17.4893 11.1662 18 10.6451 18 10C18 9.35494 17.4893 8.83379 16.8571 8.83379H5.9029L9.66382 4.99258C10.1103 4.53703 10.1103 3.79721 9.66382 3.34166C9.21737 2.88611 8.49233 2.88611 8.04587 3.34166L2.33127 9.17272L2.33484 9.17636Z",
		fill: "#0D2976"
	})
});
export default SvgArrowLeft;
